<template>
  <div class="flex flex-col flex-1">
    <div>
      <div class="flex items-center justify-between">
        <nav class="flex space-x-8">
          <div></div>
        </nav>

        <div class="flex items-center space-x-1 rounded-lg bg-gray-100 p-1">
          <!-- Add tabindex to avoid focus trap issues -->
          <div tabindex="0"></div>
          <div class="h-6 w-16 bg-slate-200 animate-pulse rounded"></div>
          <div class="h-6 w-16 bg-slate-200 animate-pulse rounded"></div>
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-slate-200 bg-white h-full flex flex-col mt-4">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonAIChatInfluencerResults',
}
</script>
